export enum EventsWindowCustom {
	userGuestReceived = 'userGuestReceived',
	languageCurrencyChanged = 'languageCurrencyChanged',
	updateToken = 'updateToken',
}
